import type { SVGProps } from 'react';
const SvgLineWeight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#line_weight_svg__a)">
      <path
        fill="currentColor"
        d="M3 17h18v-2H3v2Zm0 3h18v-1H3v1Zm0-7h18v-3H3v3Zm0-9v4h18V4H3Z"
      />
    </g>
    <defs>
      <clipPath id="line_weight_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLineWeight;
